import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalVars } from '../../../providers/globalVars';
import { Router } from '@angular/router';
import { LoadingController, ToastController, AlertController, IonRouterOutlet, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AuthData } from '../../../providers/auth-data';
import { msgfunc } from '../../../providers/msgfunc';
import { pointfunc } from '../../../providers/pointfunc';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  public registerForm;
  nickvail: boolean = true;
  recnickvail: boolean = true;
  nickName: string;
  nickNameRec: string;
  logedin: boolean = false;
  agreechk: boolean = false;
  lancode:string;
  loadingPopup:any;
  
  logedinnewuser:boolean = false;
  constructor(public fb: FormBuilder,public gv:GlobalVars, public authData: AuthData, public router: Router,private msgfunc:msgfunc,
  public loadingCtrl: LoadingController, public translate: TranslateService, public toastCtrl: ToastController, private pointfunc:pointfunc,
  public outlet:IonRouterOutlet,  public afAuth: AngularFireAuth, public afDB: AngularFireDatabase, public alertCtrl: AlertController,
  public navCtrl: NavController) { 
  /*this.lancode = gv.getLan();
  if(this.lancode == 'kr')
    this.agreechk = false;
  else
    this.agreechk = true;*/
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    if(this.authData.isAuthenticated()) 
      {
       this.logedinnewuser = true; 
       this.registerForm = this.fb.group({
            nickName: ['', Validators.compose([Validators.minLength(2), Validators.required])],
            nickNameRec: []
      });
        //console.log(auth.email);
        //console.log(auth.uid);
        //console.log(auth);
      }
     else
      {
        this.logedinnewuser = false; 
        this.registerForm = this.fb.group({
            email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
            nickName: ['', Validators.compose([Validators.minLength(2), Validators.required])],
            password: ['', Validators.compose([Validators.minLength(6), Validators.required])],
            passwordcfm: ['', Validators.compose([Validators.minLength(6), Validators.required])],
            nickNameRec: []
      });
        //console.log('auth데이터없음');
      }
      let today = new Date();
      let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
      this.afDB.database.ref('/systemlog/' + (this.gv.uid?this.gv.uid:'unregister') + '/event/' + todaystr + '/register').transaction(view=>{
        return (view || 0) + 1;
    })
  
  }
  ngOnInit() {
    
  }

  public sendverification()
  {
    firebase.auth().currentUser.sendEmailVerification().then(function() {
    // Email sent.
    }, function(error) {
    // An error happened.
    });
  }

  public chknickname()
  {
    if(this.registerForm.value['nickName'].replace(/ /g, ''))
    firebase.database().ref('/userProfile').orderByChild('nicknamelower').equalTo(this.registerForm.value['nickName'].replace(/ /g, '').toLowerCase()).once('value').then
    (nick=>{
      if(nick.val())
        this.nickvail = false;
      else
        this.nickvail = true;
    })
  }
  // 3.0부터 재등장
  public chkrecnickname()
  {
    if(this.registerForm.value.nickNameRec.replace(/ /g, ''))
    {
    firebase.database().ref('/userProfile').orderByChild('nicknamelower').equalTo(this.registerForm.value.nickNameRec.toLowerCase().replace(/ /g, '')).once('value').then
    (nick=>{
      if(nick.val())
        this.recnickvail = true;
      else
        this.recnickvail = false;
    })
    }
    else
      this.recnickvail = true;
  }


  async registerUser(){
    if(this.bad_chk(this.registerForm.value.nickName))
    {
      var thereisawordcannotbeused, okmsg;
      this.translate.get('thereisawordcannotbeused').subscribe(res=>{
        thereisawordcannotbeused = res;
      });
      this.translate.get('Confirm').subscribe(res=>{
        okmsg = res;
      });
      let alert = await this.alertCtrl.create({
            message: thereisawordcannotbeused,
            buttons: [okmsg]
          });
          alert.present();
          return;
    }
    else
      {
        firebase.database().ref('/userProfile').orderByChild('nicknamelower')
        .equalTo(this.registerForm.value.nickName.toLowerCase().replace(/ /g, '')).once('value').then(nick=>{
          if(nick.val())
            this.nickvail = false;
          else
            this.nickvail = true;
        })
        .then(_=>{
          if(this.registerForm.value.nickNameRec && this.registerForm.value.nickNameRec.replace(/ /g, ''))
          {
          firebase.database().ref('/userProfile').orderByChild('nicknamelower').equalTo(this.registerForm.value.nickNameRec.toLowerCase().replace(/ /g, '')).once('value').then
          (nick=>{
            if(nick.val())
              this.recnickvail = true;
            else
              this.recnickvail = false;
          })
          }
          else
            this.recnickvail = true;
        })
        .then(_=>{
        if(this.nickvail)
        {
        if (!this.registerForm.valid){
          var incorrectmsg;
          this.translate.get('yourinputisincorrect').subscribe(res=>{
            incorrectmsg = res;
          });
          this.presentAlert(incorrectmsg);
        } else {
          this.showloading().then(_=>{
            var recusernickname = '';
            if(this.registerForm.value.nickNameRec)
              recusernickname = this.registerForm.value.nickNameRec;

          if(this.logedinnewuser)
          {
            let user = firebase.auth().currentUser; 
            firebase.database().ref('/userProfile').child(user.uid).set({
                email: user.email,
                phone: user.phoneNumber,
                nickname:this.registerForm.value.nickName,
                nicknamelower:this.registerForm.value.nickName.toLowerCase().replace(/ /g, ''),
                nicklimit:1,
                recommended:this.registerForm.value.nickNameRec?this.registerForm.value.nickNameRec:null,
                createdDate: firebase.database.ServerValue.TIMESTAMP,
                level:{currentlevel:1},
                alarm:{personal:true,fav:true},
                uvf:true
            }).then(_=>{
              //fcm 아이디
              this.gv.unickname = this.registerForm.value.nickName;
              this.gv.ulvl = 1;
              this.authData.getlevel(null);
              this.authData.setnoti('sub',this.gv.uid);
              // 이용자 추천기능 (3.0버전부터 재개됨)
            if(recusernickname)
              {
              // 추천자 포인트 올림 / 추천자에게 메시지
              if(this.registerForm.value.nickNameRec.replace(/ /g, ''))
              {
              var recuserid;
              firebase.database().ref('/userProfile').orderByChild('nicknamelower').equalTo(this.registerForm.value.nickNameRec.toLowerCase().replace(/ /g, '')).once('value').then(
                recuser=>{
                  recuser.forEach(element => {
                    recuserid = element.key;
                    firebase.database().ref('/userProfile/' + element.key + '/invite')
                    .push({createdDate:firebase.database.ServerValue.TIMESTAMP, title:'inviteuser', uid:this.gv.uid, nickname:this.registerForm.value.nickName})
                  });
                }
              ).then(_=>{
                firebase.database().ref('/point/' + user.uid).push({pcode:'newreg', point:50, 
                  createdDate:firebase.database.ServerValue.TIMESTAMP});
                firebase.database().ref('/userData/' + user.uid + '/state/receivedprepoint').set(true);
                if(recuserid)
                {
                  var regmsgtorecommenduser;
                  this.translate.get('I have joined now').subscribe(res=>{
                    regmsgtorecommenduser = res;
                  });
                  firebase.database().ref('/point/' + user.uid).push({pcode:'fillrec', point:50, nickname:this.registerForm.value.nickNameRec, recuid:recuserid,
                  createdDate:firebase.database.ServerValue.TIMESTAMP}).then(_=>this.pointfunc.showpointani(50))
                  /*
                  firebase.database().ref('/userProfile/' + recuserid + '/invite').push({
                    nickname:this.registerForm.value.nickNameRec,
                    title:"inviteuser",
                    uid:user.uid,
                    createdDate:firebase.database.ServerValue.TIMESTAMP
                  })*/
                  /* 포인트 주는 시점을 이메일 인증후로 변경 */
                  
                  this.msgfunc.sendmsg(user.uid, recuserid, regmsgtorecommenduser, this.registerForm.value.nickName);
                  setTimeout(_=> {
                    this.presentToast("추천인에게 가입했다는 메시지를 보내드렸습니다.");
                  }, 3000);
                }
                })
                this.loadingPopup.dismiss();
                this.outlet.pop();
                var donesetting;
                this.translate.get('donesetting').subscribe(res=>{
                  donesetting = res;
                });
                // 즐겨찾기 설정
                if(this.gv.ufavlist)
                {
                  let favdata = [];
                  this.gv.ufavlist.forEach(fav=>{
                    favdata.push({chid:fav.chid,isChecked:fav.isChecked?fav.isChecked:null,
                      alarm:fav.alarm?fav.alarm:null,loc:fav.loc?fav.loc:null,
                      customtitle:fav.customtitle?fav.customtitle:null})
                    //if(fav.alarm)
                      this.authData.setnoti('sub',fav.chid);
                  })
                  firebase.database().ref('/userData/' + this.gv.uid + '/favlist').set(favdata);
                }
                else{
                  this.gv.needfillfav = true;
                }
                if(this.gv.loc)
                  firebase.database().ref('/userProfile/' + this.gv.uid + '/loc').set(this.gv.loc); 
                
                this.presentToast(donesetting);
                let today = new Date();
                let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
                this.afDB.database.ref('/systemlog/' + (user.uid?user.uid:'unregister') + '/event/' + todaystr + '/regsocial').transaction(view=>{
                  return (view || 0) + 1;
                })
                // this.router.navigate(['/tabs/home']);
                  // this.navCtrl.navigateBack('/tabs/pfmenu');
                  this.navCtrl.pop().then(_=>{
                    this.navCtrl.navigateForward('/tabs/home');
                  });
                }
                }
              else{
                this.loadingPopup.dismiss();
                this.outlet.pop();
                var donesetting;
                this.translate.get('donesetting').subscribe(res=>{
                  donesetting = res;
                });
                // 즐겨찾기 설정
                if(this.gv.ufavlist)
                {
                  let favdata = [];
                  this.gv.ufavlist.forEach(fav=>{
                    favdata.push({chid:fav.chid,isChecked:fav.isChecked?fav.isChecked:null,
                      alarm:fav.alarm?fav.alarm:null,loc:fav.loc?fav.loc:null,
                      customtitle:fav.customtitle?fav.customtitle:null})
                    //if(fav.alarm)
                      this.authData.setnoti('sub',fav.chid);
                  })
                  firebase.database().ref('/userData/' + this.gv.uid + '/favlist').set(favdata);
                }
                else{
                  this.gv.needfillfav = true;
                }
                if(this.gv.loc)
                  firebase.database().ref('/userProfile/' + this.gv.uid + '/loc').set(this.gv.loc); 
                
                this.presentToast(donesetting);
                let today = new Date();
                let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
                this.afDB.database.ref('/systemlog/' + (user.uid?user.uid:'unregister') + '/event/' + todaystr + '/regsocial').transaction(view=>{
                  return (view || 0) + 1;
                })
                // this.router.navigate(['/tabs/home']);
                // this.navCtrl.navigateBack('/tabs/pfmenu');
                this.navCtrl.pop().then(_=>{
                  this.navCtrl.navigateForward('/tabs/home');
                });
              }
            })
          }
          else{  
          this.authData.registerUser(
              this.registerForm.value.email,  
              this.registerForm.value.password,
              this.registerForm.value.nickName,
              this.registerForm.value.nickNameRec
            )
          .then(rst => {
            this.gv.unickname = this.registerForm.value.nickName;
            this.gv.ulvl = 1;
            this.authData.getlevel(null);
            this.loadingPopup.dismiss();
            this.outlet.pop();
            //fcm 아이디
            this.authData.setnoti('sub',this.gv.uid);

            // 즐겨찾기 설정
            if(this.gv.ufavlist)
            {
              let favdata = [];
              this.gv.ufavlist.forEach(fav=>{
                favdata.push({chid:fav.chid,isChecked:fav.isChecked?fav.isChecked:null,
                      alarm:fav.alarm?fav.alarm:null,loc:fav.loc?fav.loc:null,
                      customtitle:fav.customtitle?fav.customtitle:null})
                //if(fav.alarm)
                  this.authData.setnoti('sub',fav.chid);
              })
              firebase.database().ref('/userData/' + this.gv.uid + '/favlist').set(favdata); 
              //fcm필요           
            }
            else{
              this.gv.needfillfav = true;
            }
            if(this.gv.loc)
              firebase.database().ref('/userProfile/' + this.gv.uid + '/loc').set(this.gv.loc); 
            
            var donesetting;
            this.translate.get('donesetting').subscribe(res=>{
              donesetting = res;
            });
            this.presentToast(donesetting);
            // this.router.navigate(['/tabs/home']);
            this.navCtrl.pop().then(_=>{
              this.navCtrl.navigateForward('/tabs/home');
            });

            // 이용자 추천기능 (3.0버전부터 재개됨)
            if(recusernickname)
              {
              // 추천자 포인트 올림 / 추천자에게 메시지
              if(this.registerForm.value.nickNameRec.replace(/ /g, ''))
              {
              var recuserid;
              firebase.database().ref('/userProfile').orderByChild('nicknamelower').equalTo(this.registerForm.value.nickNameRec.toLowerCase().replace(/ /g, '')).once('value').then(
                recuser=>{
                  recuser.forEach(element => {
                    recuserid = element.key;
                    firebase.database().ref('/userProfile/' + element.key + '/invite')
                    .push({createdDate:firebase.database.ServerValue.TIMESTAMP, title:'inviteuser', uid:this.gv.uid, nickname:this.registerForm.value.nickName})
                  });
                }
              ).then(_=>{
                if(recuserid)
                {
                  var regmsgtorecommenduser;
                  this.translate.get('I have joined now').subscribe(res=>{
                    regmsgtorecommenduser = res;
                  });
                  firebase.database().ref('/point/' + this.gv.uid).push({pcode:'fillrec', point:50, nickname:this.registerForm.value.nickNameRec, recuid:recuserid,
                  createdDate:firebase.database.ServerValue.TIMESTAMP}).then(_=>this.pointfunc.showpointani(50))

                  /*
                  firebase.database().ref('/userProfile/' + recuserid + '/invite').push({
                    nickname:this.registerForm.value.nickNameRec,
                    title:"inviteuser",
                    uid:this.gv.uid,//recuserid,
                    createdDate:firebase.database.ServerValue.TIMESTAMP
                  })*/

                  /* 이메일 인증후 포인트 줘야함. function으로 대체
                  firebase.database().ref('/point/' + recuserid).push({pcode:'getrec', point:100, nickname:this.registerForm.value.nickName, recuid:this.gv.uid,
                  createdDate:firebase.database.ServerValue.TIMESTAMP});*/
                  this.msgfunc.sendmsg(this.gv.uid, recuserid, regmsgtorecommenduser, this.registerForm.value.nickName);
                  setTimeout(_=> {
                    this.presentToast("추천인에게 가입했다는 메시지를 보내드렸습니다.");
                  }, 3000);
                  
                }
              })
              }
              }

              /* 공지사항 새멤버 알림기능 *1.7부터 제거됨 
              var join, wcjoin, wcch, newuser;
              this.translate.get('join').subscribe(res=>{
                join = res;
              });
              this.translate.get('welcometojoin').subscribe(res=>{
                wcjoin = res;
              });
              this.translate.get('welcometochannelhaveagoodday').subscribe(res=>{
                wcch = res;
              });
              this.translate.get('newuserregistered').subscribe(res=>{
                newuser = res;
              });
              
              var chcat = this.gv.getLoc() + '_' + this.gv.getLan()
              this.afDB.database.ref('/notice/' + chcat).push({title:'[' + join + '] ' + this.nickName + wcjoin, 
              description:this.nickName + wcch, 
              createdDate:firebase.database.ServerValue.TIMESTAMP, read:0})
              */

              /* 신규유저 관리자 알림기능 2.0부터 제거됨 - 클라우드 펑션으로 대치예정
              var apiUrl = 'https://fcm.googleapis.com/fcm/send';
              var data =
              {
              "notification":{
                  "title":newuser,   //Any value 
                  "body": this.nickName, //Any value 
                      "click_action":"FCM_PLUGIN_ACTIVITY",   //Must be present for Android 
                  },
                  "data":{
                      "title":newuser,   //Any value 
                      "message":this.nickName,  //Any value 
                      "type":"newmember",  //Any data to be retrieved in the notification callback 
                      "id":this.nickName,
                  },
                  "to":"/topics/admin",
                  "priority":"high", //If not set, notification won't be delivered on completely closed iOS app 
              }
              new Promise((resolve, reject)=>{
              let headers = new Headers();
                  headers.append('Content-Type', 'application/json');
                  headers.append('Authorization', 'key=AAAAZv3z3gE:APA91bHg8qjJ-eilTN-kTY7CliN2UlzOAJ4QpbwKoAlh3w0p6tnb0nODSC8Rs45fKNuM5bh1PjctPSVua_mhFT67NY1h_wEKXExyPCk8lgZQolj_A8cDe3WjAKgdxRRlFQsOZ080BD3N');

                  this.http.post(apiUrl, JSON.stringify(data), {headers: headers})
                  .subscribe(res => {
                      //console.log(res);
                      resolve(res);
                      this.loadingPopup.dismiss();
                      //this.logedin = true;
                  }, (err) => {
                      //console.log(err);
                      reject(err);
                      this.loadingPopup.dismiss();
                      //this.logedin = true;
                  });
                  }).then(_=>{
                   
                    this.afDB.object('/userProfile/' + this.gv.uid).update(
                    {
                    info:{
                    lancode:this.gv.getLan(), //this.settingForm.value.language,
                    location:'cairns',
                    //gender:this.settingForm.value.gender,
                    //birthyear:this.settingForm.value.birthyear,
                    //job:this.settingForm.value.job,
                    //state:this.settingForm.value.state
                    },
                    alram:{community:true, msg:true, place:true, share:true, talent:true, trade:true, work:true}
                  }).then(_=> {
                    var donesetting;
                    this.translate.get('donesetting').subscribe(res=>{
                      donesetting = res;
                    });
                    this.presentToast(donesetting);
                    this.nav.setRoot('CoverPage');
                    })
                  })
                  */
              
          }, (error) => { 
            if(error.code == 'auth/email-already-in-use')
            {
              var emailinuse;
              this.translate.get('thisemailisalreadyinusepleasecheckagain').subscribe(res=>{
                emailinuse = res;
              });
              this.presentAlert(emailinuse);
              this.loadingPopup.dismiss();
            }
            else{
            var errorMessage: string = error.message;
              this.loadingPopup.dismiss();
              this.presentAlert(errorMessage);     
              } 
          });
          }
          });
        }
        }
        })
      }
  }

  async showloading(){
    var creatingmsg;
    this.translate.get('creatingaccount').subscribe(res=>{
      creatingmsg = res;
    });
    this.loadingPopup = await this.loadingCtrl.create({
      spinner: 'crescent', 
      message: creatingmsg
    });
    this.loadingPopup.present();
  }

  async presentAlert(title) {
    var confirmmsg;
    this.translate.get('Confirm').subscribe(res=>{
      confirmmsg = res;
    });
    let alert = await this.alertCtrl.create({
      message: title,
      buttons: [confirmmsg]
    });
    alert.present();
  }
 
  async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
    message: message,
    position: 'bottom',
    duration: 2200
    });
    toast.present();
    }


    bad_chk(str) { // 욕 필터링 , 스크립트 아이프레임도 필터링
      if (str == '') return true;
      var badword, chword, pattern_regex, pattern, emoji_regex, emojis;
      // this.translate.get('badword').subscribe(res => {badword = res});
      // this.translate.get('chword').subscribe(res => {chword = res});
      badword = "'개새끼','개색기','개색끼','개자식','개보지','개자지','개년','개걸래','개걸레','지랄','씨발','씨팔','씹년','씹새끼','씨부랄','씨바랄','씹창','씹탱','씹보지','씹자지','씨방세','씨방새','씨펄','시펄','십탱','섹스','씨박','썅','쌍놈','쌍넘','싸가지','쓰벌','씁얼','상넘이','상놈의','상놈이','상놈을','좆','좃','졸라','존나','존만한','같은년','넣을년','버릴년','부랄년','바랄년','미친년','니기미','니미씹','니미씨','니미럴','니미랄','후레아들','호로새끼','후레자식','후래자식','후라들년','후라들넘','빠구리','sex','fuck','shit','병신'";
      chword = "'admin','system','관리','채널','channel'";
      // pattern_regex = /^[a-zA-Zㄱ-힣0-9]*$/;
      // 중국어 한자 // [\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9\U00020000-\U0002A6D6\U0002A700-\U0002B734\U0002B740-\U0002B81D\U0002B820-\U0002CEA1\U0002CEB0-\U0002EBE0\U0002F800-\U0002FA1D]
      pattern_regex = '^[a-zA-Zㄱ-힣0-9一-龠ぁ-ゞァ-ヶ々〆〤]*$'; // 영문, 국문, 숫자, 한자, 일문, (중문은 따로 안넣었는데 한자에 간체가 포함되는듯?)
      pattern = str.match(pattern_regex);
      if( pattern == null ) {
        console.log("pattern = " + pattern);
        return true; // str을 match 했을때, 정규표현식 외 문자가 있으면 null이 찍힘
      }
      // emoji_regex = '(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])';
      // emojis = str.toLowerCase().match(emoji_regex);
      // var YokList = (badword + "," + chword + "," + emojis).replace(/\'/g, '').split(",");
      var YokList = (badword + "," + chword).replace(/\'/g, '').split(",");
      var Tmp;
      for (var i = 0; i < YokList.length; i++) {
        Tmp = str.toLowerCase().indexOf(YokList[i]);
        if (Tmp >= 0) {
          console.log("YokList[i] = " + YokList[i]);
          return true;
        }
      }
      //루프를 돌고난 후에도 정상아웃하면 욕없음
      return false;
    }

  async viewagree(){
    let alert = await this.alertCtrl.create({
      header: '약관동의',
      message: `본 앱을 이용시 아래 내용을 확인 해 주시기 바랍니다.<br><br><br>
                    <b>제 1장 총칙</b><br><br>
                    제 1조 (목적)<br>
                    본 이용약관(이하 '약관')은 CHANNEL(이하 '앱')이 제공하는 모든 서비스(이하 '서비스')의
                    이용조건 및 절차, 이용자와 앱의 권리, 의무 및 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.
                    이 약관은 본 앱의 기본 약관에 적용됩니다<br><br>
                    제 2 조 (약관의 효력 및 변경)<br>
                    앱은 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 약관의규제에관한법률, 전기통신기본법, 전기통신사업법, 정보통신윤리위원회심의규정, 정보통신윤리강령, 프로그램보호법 등 관계법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
                    앱 담당자가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 앱의 약관화면에 표시하며 그 적용일자 7일이전부터 적용일자 전일까지 공지하며, 적용일에 효력이 발생합니다.
                    변경된 약관의 부지로 인한 회원의 피해는 앱에서 책임지지 않습니다.
                    회원은 변경된 약관에 동의하지 않을 경우 탈퇴(해지) 할 수 있으며, 변경된 약관의 효력 발생일로부터 7일이 내에 거부의사를 표시하지 아니하고 서비스를 계속 사용할 경우 변경된 약관에 동의한 것으로 간주합니다.
                    <br><br>제 3 조 (용어의 정의)<br>
                    본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
                    1. 이용자 : 본 약관에 따라 앱이 제공하는 서비스를 받는 자를 말합니다.
                    2. 이용계약 : 서비스 이용과 관련하여 앱과 이용자간에 체결하는 계약을 말합니다.
                    3. 회원 : 앱에 개인정보를 제공하고, 서비스를 이용하기 위해 앱과 이용계약을 체결하려고 하는 자를 말합니다.
                    4. 이용자번호(ID) : 이용자의 식별과 이용자의 서비스 이용을 위하여 이용자가 선정하고 앱이 부여하는 문자와 숫자의 조합을 말합니다.
                    5. 비밀번호 : 이용자가 등록회원과 동일인인지 신원을 확인하고 통신상의 자신의 개인정보보호를 위하여 이용자 자신이 선정한 문자와 숫자의 조합을 말합니다.
                    6. 탈퇴(해지) : 앱 담당자 또는 이용자가 이용계약을 해약하는 것을 말합니다.
                    본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계법령, 개별서비스에 대한 별도약관 및 이용규정에서 정의합니다.
                    
                    <br><br><br><b>제 2장 이용계약의 성립 및 해지</b><br><br>
                    제 4 조 (이용계약의 성립)<br>
                    이용계약은 이용자가 본 약관 내용에 대한 동의와 이용신청에 대하여 앱의 이용승낙으로 성립합니다.
                    본 이용약관에 대한 동의는 이용신청 당시 해당 앱의 '동의함' 을 선택함으로써 의사표시를 합니다.
                    이용고객이 이 약관에 따라 서비스 이용을 신청을 하는 것은 앱이 제정한 "개인정보처리방침", "저작권정책" 등 각종 정책에 대해 동의한 것으로 간주됩니다.
                    <br><br>제 5 조 (개인정보의 보호 및 사용)<br>
                    앱은 관계법령이 정하는 바에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위해 노력합니다.
                    이용자 개인정보는 관련법령 및 앱의 개인정보 처리방침이 적용됩니다. 단, 앱에 포함된 링크 또는 배너를 클릭하여 다른 사이트로 옮겨갈 경우 앱의 개인정보 처리방침이 적용되지 않습니다.
                    앱의 회원 정보는 다음과 같이 수집, 사용, 관리, 보호됩니다.
                    1. 개인정보의 수집 : 앱은 회원가입 시 회원이 제공하는 정보를 통하여 회원의 정보를 수집합니다.
                    2. 개인정보의 사용 : 앱 서비스 제공과 관련하여 수집된 회원의 신상정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다.
                    3. 개인정보의 관리 : 회원은 개인정보의 보호 및 관리를 위하여 수시로 회원의 개인정보를 수정/삭제할 수 있습니다. 수신되는 정보 중 불필요하다고 생각되는 부분도 변경/조정할 수 있습니다.
                    
                    개인정보의 보호 : 회원의 개인정보는 오직 회원만이 열람/수정/삭제 할 수 있으며, 이는 전적으로 회원의 이용자ID와 비밀번호에 의해 관리되고 있습니다. 따라서 타인에게 회원의 이용자ID와 비밀번호를 알려주어서는 안되며, 작업 종료 시에는 반드시 로그아웃 하고, 앱 창을 닫아야 합니다.
                    
                    4. 회원이 앱 약관에 따라 이용신청을 하는 것은 앱이 본 약관에 따라 신청서에 기재된 회원정보를 수집, 이용하는 것에 동의하는 것으로 간주됩니다.
                    <br><br>제 6 조 (사용자의 정보 보안)<br>
                    앱은 회원의 귀책사유로 인해 노출된 정보에 대해서 일체의 책임을 지지 않습니다.
                    회원의 이용자ID나 비밀번호가 부정하게 사용되었다는 사실을 발견한 경우에는 즉시 앱 담당자에게 신고하여야 합니다. 신고를 하지 않음으로 인해 발생하는 모든 책임은 회원 본인에게 있습니다.
                    <br><br>제 7 조 (이용 신청 및 제한)<br>
                    회원가입은 신청자가 제공하는 소정의 가입신청 양식에서 요구하는 사항을 기록하여 가입을 완료하는 것으로 성립됩니다.
                    앱은 만 12세미만의 아동은 회원으로 가입할 수 없습니다.
                    앱은 다음 각 호에 해당하는 회원가입에 대하여는 가입을 취소할 수 있습니다.
                    1. 다른 사람의 명의를 사용하여 신청하였을 때
                    2. 회원가입 신청서의 내용을 허위로 기재하였거나 신청하였을 때
                    3. 사회의 안녕 질서 혹은 미풍양속을 저해할 목적으로 신청하였을 때
                    4. 다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을 때
                    5. 앱을 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우
                    6. 기타 앱이 정한 회원가입요건이 미비 되었을 때
                    앱은 다음 각 항에 해당하는 경우 그 사유가 해소될 때까지 이용계약 성립을 유보할 수 있습니다.
                    1. 서비스 관련 제반 용량이 부족한 경우
                    2. 기술상 장애 사유가 있는 경우
                    앱은 자체 개발하거나 다른 기관과의 협의 등을 통해 서비스를 제공하며, 서비스의 내용 변경 시 이용자에게 공지하고 변경하여 제공할 수 있습니다.
                    <br><br>제 8 조 (이용자ID 부여 및 변경 등)<br>
                    앱은 이용자에 대하여 약관에 정하는 바에 따라 이용자 ID를 부여합니다.
                    이용자ID는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경 하고자 하는 경우에는 해당 ID를 해지하고 재가입해야 합니다.
                    이용자ID는 이용자 본인의 동의 하에 기타 타 부처의 정보제공사이트의 이용자ID와 연결될 수 있습니다
                    이용자ID는 다음 각 호에 해당하는 경우에는 이용자 또는 앱 담당자의 요청으로 변경할 수 있습니다.
                    1. 이용자ID가 이용자의 전화번호 등으로 등록되어 사생활침해가 우려되는 경우
                    2. 타인에게 혐오감을 주거나 미풍양속에 저해할 목적으로 신청한 경우
                    3. 기타 합리적인 사유가 있는 경우
                    서비스 이용자ID 및 비밀번호의 관리책임은 회원에게 있습니다. 이를 소홀히 관리하여 발생하는 서비스 이용상의 손해 또는 제3자에 의한 부정이용 등에 대한 책임은 회원에게 있으며 앱은 그에 대한 책임을 일절 지지 않습니다.
                    기타 이용자 개인정보 관리 및 변경 등에 관한 사항은 앱이 정하는 바에 의합니다.
                    
                    <br><br><br><b>제 3 장 서비스의 이용 및 이용제한</b>
                    <br><br>제 9 조 (서비스 이용시간)<br>
                    서비스 이용시간은 앱의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다.
                    제1항의 이용시간 중 정기점검 등의 필요로 인하여 앱이 정한 날 또는 시간은 예외로 합니다.
                    <br><br>제 10 조 (서비스의 중지 및 중지에 대한 공지)<br>
                    이용자는 서비스에 보관/전송된 메시지의 내용이 앱의 관리 범위 외의 서비스 설비 장애 및 기타 불가항력에 의하여 보관/삭제/전송/ 손실이 있을 경우에 앱은 관련 책임을 부담하지 아니합니다.
                    천재지변, 국가비상사태 등 앱이 정상적인 서비스 제공이 불가능할 경우 일시적으로 서비스를 제한, 중지시킬 수 있으며 사전 또는 사후 회원에게 중지사유 및 기간을 공지합니다.
                    앱의 사정으로 서비스를 영구적으로 중단하여야 할 경우에는 사전 공지기간은 1개월로 합니다.
                    앱은 긴급한 시스템 점검, 증설 및 교체 등 부득이한 사유로 인하여 예고 없이 일시적으로 서비스를 중단할 수 있으며, 새로운 서비스로의 교체 등 앱이 적절하다고 판단하는 사유에 의하여 현재 제공되는 서비스를 완전히 중단할 수 있습니다.
                    앱은 서비스를 특정범위로 분할하여 각 범위별로 이용가능시간을 별도로 지정할 수 있습니다. 다만 이 경우 그 내용을 공지합니다.
                    앱이 통제할 수 없는 사유로 인한 서비스중단의 경우(시스템관리자의 고의, 과실 없는 디스크장애, 시스템다운 등)에 사전통지가 불가능하며 타인(PC통신회사, 기간통신사업자 등)의 고의, 과실로 인한 시스템중단 등의 경우에는 통지하지 않습니다.
                    앱은 회원이 본 약관의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 제한 및 중지하거나 회원의 동의 없이 이용계약을 해지할 수 있습니다. 이 경우 앱은 위 이용자의 접속을 금지할 수 있습니다.
                    <br><br>제 11 조 (서비스 이용제한)<br>
                    이용자가 제공하는 정보의 내용이 허위인 것으로 판명되거나, 허위가 있다고 의심할 만한 합리적인 사유가 발생할 경우 앱은 이용자의 본 서비스 사용을 일부 또는 전부 중지할 수 있으며, 이로 인해 발생하는 불이익에 대해 책임을 부담하지 아니합니다.
                    앱은 이용자가 본 약관 제16조(이용자의 의무)등 본 약관의 내용에 위배되는 행동을 한 경우, 임의로 서비스 사용을 제한 및 중지할 수 있습니다. 이 경우 앱은 이용자의 접속을 금지할 수 있습니다.
                    <br><br>제 12 조 (게시물의 관리)<br>
                    이용자가 게시한 게시물의 저작권은 이용자가 소유하며, 앱은 서비스 내에 이를 게시할 수 있는 권리를 갖습니다.
                    앱은 다음 각 호에 해당하는 게시물이나 자료를 사전통지 없이 삭제하거나 이동 또는 등록 거부를 할 수 있습니다.
                    1. 본서비스 약관에 위배되거나 상용 또는 불법, 음란, 저속하다고 판단되는 게시물을 게시한 경우
                    2. 다른 회원 또는 제 3자에게 심한 모욕을 주거나 명예를 손상시키는 내용인 경우
                    3. 공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는 경우
                    4. 불법복제 또는 해킹을 조장하는 내용인 경우
                    5. 영리를 목적으로 하는 광고일 경우
                    6. 범죄와 결부된다고 객관적으로 인정되는 내용일 경우
                    7. 다른 이용자 또는 제 3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                    8. 앱에서 규정한 게시물 원칙에 어긋나거나, 게시판 성격에 부합하지 않는 경우
                    9. 기타 관계법령에 위배된다고 판단되는 경우 . 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공하는 행위
                    이용자의 게시물이 타인의 저작권을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 이용자가 부담하여야 합니다.
                    <br><br>제 13 조 (게시물에 대한 저작권)<br>
                    이용자가 게시한 게시물의 저작권은 게시한 이용자에게 귀속됩니다. 또한 앱은 게시자의 동의 없이 게시물을 상업적으로 이용할 수 없습니다. 다만 비영리 목적인 경우는 그러하지 아니하며, 또한 서비스내의 게재권을 갖습니다.
                    앱은 회원이 게시하거나 등록하는 서비스 내의 내용물, 게시 내용에 대해 제12조 각 호에 해당된다고 판단되는 경우 사전통지 없이 삭제하거나 이동 또는 등록 거부할 수 있습니다.
                    앱은 회원이 게시한글을 상업적 목적으로 사용하지 않지만, 앱홍보를 위한 목적으로 게시글을 타사이트로 옮길수 있으며 회원이 타사이트에 게제하는것을 원치 않는다는 의사표시를 하실 경우 타사이트에 글을 삭제 및 사용하지 않습니다.
                    <br><br>제 14 조 (정보 제공 및 홍보물 게재)<br>
                    앱은 서비스를 운영함에 있어서 각종 정보를 앱에 게재하는 방법을 도움말 혹은 전자우편 발송 등으로 회원에게 제공할 수 있습니다.
                    앱은 서비스에 적절하다고 판단되거나 공익성이 있는 홍보물을 게재할 수 있습니다.
                    
                    <br><br><br><b>제 4 장 의무 및 책임</b>
                    <br><br>제 15 조 (앱의 의무)<br>
                    앱은 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 지속적·안정적으로 서비스를 제공하기 위해 노력할 의무가 있습니다.
                    앱은 이용자의 개인 신상 정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 다만, 관계법령에 의해 국가기관의 요구나 정보통신윤리위원회의 요청 등 법률의 규정에 따른 적법한 절차에 의한 경우에는 그러하지 아니합니다.
                    앱은 계속적이고 안정적인 서비스의 제공을 위하여 설비에 장애가 생기거나 멸실된 때에는 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구합니다.
                    앱은 이용자의 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를 거쳐 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우는 이용자에게 그 사유와 처리일정을 통보하여야 합니다.
                    앱은 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.
                    <br><br>제 16 조 (이용자의 의무)<br>
                    회원가입 신청 및 회원정보 변경 시 요구되는 정보는 사실에 근거하여 기입하여야 합니다. 만약 허위 또는 타인의 정보를 등록할 경우 일체의 권리를 주장할 수 없습니다.
                    이용자는 서비스를 이용하여 얻은 정보를 앱 혹은 정보제공자의 사전승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.
                    이용자는 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.
                    1. 회원가입 신청 또는 회원정보 변경 시 허위내용을 기재하거나 다른 회원의 비밀번호와 ID를 도용하여 부정 사용하는 행위
                    2. 저속, 음란, 모욕적, 위협적이거나 타인의 Privacy를 침해할 수 있는 내용을 전송, 게시, 게재, 전자우편 또는 기타의 방법으로 전송하는 행위
                    3. 앱 운영진, 직원 또는 관계자를 사칭하는 행위
                    4. 서비스를 통하여 전송된 내용의 출처를 위장하는 행위
                    5. 법률, 계약에 의해 이용할 수 없는 내용을 게시, 게재, 전자우편 또는 기타의 방법으로 전송하는 행위
                    6. 앱으로부터 특별한 권리를 부여 받지 않고 앱의 클라이언트 프로그램을 변경하거나, 서버 해킹 및 컴퓨터바이러스 유포, 웹사이트 또는 게시된 정보의 일부분 또는 전체를 임의로 변경하는 행위
                    7. 타인의 특허, 상표, 영업비밀, 저작권, 기타 지적재산권을 침해하는 내용을 게시, 게재, 전자우편 또는 기타의 방법으로 전송하는 행위
                    8. 앱의 승인을 받지 아니한 광고, 판촉물, 스팸메일, 행운의 편지, 피라미드 조직 기타 다른 형태의 권유를 게시, 게재, 전자우편 또는 기타의 방법으로 전송하는 행위
                    9. 다른 사용자의 개인정보를 수집, 저장, 공개하는 행위
                    10. 범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위
                    11. 선량한 풍속, 기타 사회질서를 해하는 행위
                    12. 타인의 명예를 훼손하거나 모욕하는 행위
                    13. 타인의 지적재산권 등의 권리를 침해하는 행위
                    14. 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위
                    15. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위
                    16. 앱에 게시된 정보의 변경
                    17. 본 약관을 포함하여 기타 앱이 정한 제반 규정 또는 이용 조건을 위반하 행위
                    18. 기타 관계법령에 위배되는 행위
                    
                    <br><br><br><b>제 5 장 계약 변경 및 해지</b>
                    <br><br>제 17 조 (계약 변경 및 해지)<br>
                    회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 앱의 [마이페이지>회원탈퇴] 메뉴를 통해 가입해지를 해야 합니다.
                    회원탈퇴를 요청한 경우에는 수집된 개인정보는 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기하는 것을 원칙으로 합니다.
                    
                    <br><br><br><b>제 6 장 기 타</b>
                    <br><br>제 18 조 (앱 저작권)<br>
                    앱이 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지적재산권 및 기타 권리는 본 앱에 소유권이 있습니다.
                    이용자는 앱이 명시적으로 승인한 경우를 제외하고는 전항의 소정의 각 재산에 대해 전부 혹은 일부 수정, 배포, 상업적 이용 행위 등을 할 수 없으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.
                    <br><br>제 19 조 (관할법원)<br>
                    이 약관에 명시되지 않은 사항은 관계법령과 상관습에 따릅니다.
                    본 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 앱 소재지를 관할하는 법원으로 합니다.
                    <br><br>제 20 조 (양도금지)<br>
                    회원이 서비스의 이용권한, 기타 이용계약 상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.
                    <br><br>제 21 조 (손해배상)<br>
                    앱은 천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다.
                    앱은 기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우 책임이 면제됩니다.
                    앱은 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.
                    앱은 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우, 또는 회원이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다.
                    앱은 서비스에 표출된 어떠한 의견이나 정보에 대해 확신이나 대표할 의무가 없으며 이용자나 제3자에 의해 표출된 의견을 승인하거나 반대하지 않습니다.
                    앱은 이용자 또는 기타 유관기관이 서비스에 게재한 정보에 대해 정확성, 신뢰도에 대하여 보장하지 않습니다. 따라서 앱은 이용자가 위 내용을 이용함으로 인해 입게 된 모든 종류의 손실이나 손해에 대하여 책임을 부담하지 아니합니다.
                    앱은 이용자가 서비스를 이용하며 타 이용자로 인해 입게 되는 정신적 피해에 대하여 보상할 책임을 지지 않습니다.
                    <br><br>부 칙 1. (시행일)<br>이 약관은 2018년 2월 1일부터 적용되며, 추후 약관 개정시 개정된 약관의 적용일 이전 가입자도 개정된 약관의 적용을 받습니다.`,
      buttons: [{text:'동의합니다.', cssClass:'altcls',handler: () => {
        this.agreechk = true;
      }
      }],
      cssClass: 'alertCustomCss'
    });
    alert.present();
  }
}
